const loadMoreLink = document.querySelector('.load_more');
const lessMoreLink = document.querySelector('.less_more');
const truncateText = document.querySelector('.truncate_text');
const fullText = document.querySelector('.full_text');

loadMoreLink.addEventListener('click', function() {
  truncateText.style.display = 'none';
  fullText.style.display = 'block';
  lessMoreLink.style.display = 'inline';
  loadMoreLink.style.display = 'none';
});

lessMoreLink.addEventListener('click', function() {
  truncateText.style.display = 'block';
  fullText.style.display = 'none';
  lessMoreLink.style.display = 'none';
  loadMoreLink.style.display = 'inline';
});